export enum SlidesAccess {
  Public = 'public',
  Restricted = 'restricted',
}

export enum SlidesImportMode {
  Present = 'present',
  Collaborate = 'collaborate',
}
